import { FC } from "react";

import { Box } from "@mui/material";

import Image from "@/components/Image/Image";
import { DashboardTypography } from "@/dashboard-design-system/Typography";

interface EmbedInstructionsIllustrationProps {
  src: string;
  illustrationWidth: number;
  scale: number;
  captions: string[];
}

export const EmbedInstructionsIllustration: FC<EmbedInstructionsIllustrationProps> = ({
  src,
  illustrationWidth,
  scale,
  captions,
}) => (
  <Box
    component="figure"
    sx={(theme) => ({
      margin: 0,
      alignSelf: "center",
      width: theme.typography.pxToRem(illustrationWidth * scale),
      maxWidth: "100%",
    })}
  >
    <Image src={src} alt="" height={undefined} width="100%" style={{ display: "block" }} />
    <Box component="figcaption">
      <Box
        component="ol"
        role="list"
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(${captions.length}, minmax(0, 1fr))`,
          columnGap: `${(32 / illustrationWidth) * 100}%`,
          margin: 0,
          padding: 0,
          listStyle: "none",
        }}
      >
        {captions.map((caption) => (
          <DashboardTypography
            key={caption}
            component="li"
            variant="body2"
            vibe="text-neutral-intense"
            sx={{ textAlign: "center", fontWeight: 600, overflowWrap: "anywhere" }}
          >
            {caption}
          </DashboardTypography>
        ))}
      </Box>
    </Box>
  </Box>
);
